import "./Memberss.css";
import DashboardLayout from "../../layouts/DashboardLayout";
import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { getMembers, deleteMember } from "../../services/memberService";
import { updateMember } from "../../services/memberService";
import { addPayment } from "../../services/paymentService";
import { generateMemberCard } from "../../utils/generateMemberCard";
import { getSettings } from "../../services/settingsService";
import { FaSearch } from "react-icons/fa";
// import { useGym } from "../../context/GymContext";
import { getWorkoutPlans } from "../../services/workoutPlanService";
import { generateWorkoutPDF } from "../../utils/generateWorkoutPDF";
import { generateDietPDF } from "../../utils/generateDietPDF";
import { getDietPlans } from "../../services/dietPlanService";
import { getPlans } from "../../services/membershipService";

import {
  FaWhatsapp,
  // FaIdCard,
  FaDumbbell,
  FaAppleAlt,
  // FaUser,
  // FaPhone,
  // FaCreditCard,
  // FaCalendarAlt,
  // FaExternalLinkAlt,
  // FaCheckCircle,
} from "react-icons/fa";

export default function Members() {
  const navigate = useNavigate();

  // const gym = useGym();

  const [members, setMembers] = useState([]);
  const [workoutPlans, setWorkoutPlans] = useState([]);
  const [dietPlans, setDietPlans] = useState([]);
  const [search, setSearch] = useState("");
  const [gymSettings, setGymSettings] = useState(null);
  const [membershipPlans, setMembershipPlans] = useState([]);

  useEffect(() => {
    loadMembers();
    loadGymSettings();
    loadWorkoutPlans();
    loadMembershipPlans();
    loadDietPlans();
  }, []);

  const loadGymSettings = async () => {
    const data = await getSettings();
    setGymSettings(data);
  };

  const loadMembers = async () => {
    try {
      const data = await getMembers();
      setMembers(data);
    } catch (error) {
      console.error(error);
    }
  };

  const loadWorkoutPlans = async () => {
    try {
      const data = await getWorkoutPlans();

      setWorkoutPlans(data);
    } catch (error) {
      console.error(error);
    }
  };

  const loadDietPlans = async () => {
    try {
      const data = await getDietPlans();
      setDietPlans(data);
    } catch (error) {
      console.error(error);
    }
  };

  // const getMemberPlan = (member) => {
  //   return membershipPlans.find((plan) => plan.id === member.membershipPlanId);
  // };

  const loadMembershipPlans = async () => {
    try {
      const data = await getPlans();

      setMembershipPlans(data);
    } catch (error) {
      console.error(error);
    }
  };

  const getWorkoutName = (id) => {
    const plan = workoutPlans.find((item) => item.id === id);

    return plan ? plan.planName : "-";
  };

  const getDietName = (id) => {
    const plan = dietPlans.find((item) => item.id === id);

    return plan ? plan.planName : "-";
  };

  const handleDelete = async (id) => {
    const confirmDelete = window.confirm(
      "Are you sure you want to delete this member?",
    );

    if (!confirmDelete) return;

    try {
      await deleteMember(id);

      loadMembers();

      alert("Member Deleted Successfully");
    } catch (error) {
      console.error(error);
      alert("Error Deleting Member");
    }
  };

  const filteredMembers = members.filter((member) =>
    member.fullName?.toLowerCase().includes(search.toLowerCase()),
  );
  // =========================================================
  // GROUP MEMBERS BY JOIN DATE
  // =========================================================

  const groupedMembers = filteredMembers.reduce((groups, member) => {
    const date = member.joinDate || "Unknown Date";

    if (!groups[date]) {
      groups[date] = [];
    }

    groups[date].push(member);

    return groups;
  }, {});

  // Newest date first
  const sortedMemberDates = Object.keys(groupedMembers).sort(
    (a, b) => new Date(b) - new Date(a),
  );

  // Format date
  const formatMemberDate = (date) => {
    if (!date || date === "Unknown Date") {
      return "Unknown Date";
    }

    const dateObject = new Date(date);

    return dateObject.toLocaleDateString("en-IN", {
      weekday: "long",
      day: "2-digit",
      month: "long",
      year: "numeric",
    });
  };

  const handleRenew = async (member) => {
    try {
      // Safety check
      if (!isExpired(member.expiryDate)) {
        alert("This member's membership is still active.");
        return;
      }

      // Find current membership plan
      const selectedPlan = membershipPlans.find(
        (plan) => plan.id === member.membershipPlanId,
      );

      if (!selectedPlan) {
        alert("Membership plan not found.");
        return;
      }

      const days = Number(selectedPlan.duration);

      if (!days || days <= 0) {
        alert("Invalid membership plan duration.");
        return;
      }

      const amount = Number(selectedPlan.price);

      if (!amount || amount <= 0) {
        alert("Invalid membership plan price.");
        return;
      }

      // Since the membership is already expired,
      // renewal should start from TODAY.
      const today = new Date();
      today.setHours(0, 0, 0, 0);

      const newExpiry = new Date(today);
      newExpiry.setDate(newExpiry.getDate() + days);

      const newExpiryDate = newExpiry.toISOString().split("T")[0];

      // ==========================================
      // UPDATE MEMBER
      // ==========================================

      await updateMember(member.id, {
        expiryDate: newExpiryDate,
        status: "Active",
        membershipPlanId: selectedPlan.id,
        membershipPlan: selectedPlan.planName,
      });

      // ==========================================
      // CREATE PAYMENT
      // ==========================================

      await addPayment({
        memberId: member.memberId,
        memberName: member.fullName,
        membershipPlanId: selectedPlan.id,
        membershipPlan: selectedPlan.planName,
        amount: amount,
        paymentDate: new Date().toISOString().split("T")[0],
        status: "Paid",
      });

      alert(`${member.fullName}'s membership has been renewed successfully.`);

      // Refresh members
      await loadMembers();
    } catch (error) {
      console.error("Renewal Error:", error);

      alert(error.message || "Membership renewal failed.");
    }
  };
  const isExpired = (expiryDate) => {
    if (!expiryDate) return false;

    const today = new Date();
    today.setHours(0, 0, 0, 0);

    const expiry = new Date(expiryDate);
    expiry.setHours(0, 0, 0, 0);

    return expiry < today;
  };
  return (
    <DashboardLayout>
      <div className="members-main-container">
        {" "}
        <div className="members-header">
          <div className="header-text">
            <h1>Members Management</h1>
            <p style={{ fontWeight: "bold" }}>
              Manage gym members, memberships, renewals and ID cards.
            </p>
          </div>

          <button className="add-btn" onClick={() => navigate("/members/add")}>
            + Add Member
          </button>
        </div>
        <div className="search-section">
          <FaSearch className="search-icon" />

          <input
            type="text"
            placeholder="Search member by name..."
            value={search}
            onChange={(e) => setSearch(e.target.value)}
          />
        </div>
        {/* =========================================================
    MEMBERS GROUPED BY JOIN DATE
========================================================= */}
        {filteredMembers.length > 0 ? (
          <div className="members-date-sections">
            {sortedMemberDates.map((date) => {
              const dateMembers = groupedMembers[date];

              return (
                <div className="members-date-section" key={date}>
                  {/* =================================================
              DATE HEADER
          ================================================= */}

                  <div className="members-date-header">
                    <div>
                      <h2>📅 {formatMemberDate(date)}</h2>

                      <span>
                        {dateMembers.length} Member
                        {dateMembers.length !== 1 ? "s" : ""}
                      </span>
                    </div>

                    {/* DATE STATISTICS */}

                    <div className="members-date-stats">
                      <div className="member-stat total">
                        <strong>{dateMembers.length}</strong>

                        <span>New Members</span>
                      </div>

                      <div className="member-stat active">
                        <strong>
                          {
                            dateMembers.filter(
                              (member) => member.status === "Active",
                            ).length
                          }
                        </strong>

                        <span>Active</span>
                      </div>
                    </div>
                  </div>

                  {/* =================================================
              TABLE
          ================================================= */}

                  <div className="table-card">
                    <table className="member-table">
                      <thead>
                        <tr>
                          <th>Member ID</th>

                          <th>Photo</th>

                          <th>Name</th>

                          <th>Phone</th>

                          <th>Email</th>

                          <th>Plan</th>

                          <th>Trainer</th>

                          {gymSettings?.features?.aiWorkout && (
                            <th>Workout Plan</th>
                          )}

                          {gymSettings?.features?.dietPlan && (
                            <th>Diet Plan</th>
                          )}

                          <th>Join Date</th>

                          <th>Expiry Date</th>

                          <th>Status</th>

                          <th>Actions</th>
                        </tr>
                      </thead>

                      <tbody>
                        {dateMembers.map((member) => {
                          return (
                            <tr key={member.id}>
                              {/* MEMBER ID */}

                              <td>
                                <span className="member-id">
                                  {member.memberId || "-"}
                                </span>
                              </td>

                              {/* PHOTO */}

                              <td>
                                <img
                                  src={
                                    member.photo ||
                                    "https://placehold.co/60x60?text=User"
                                  }
                                  alt={member.fullName}
                                  className="member-photo"
                                />
                              </td>

                              {/* NAME */}

                              <td>{member.fullName}</td>

                              {/* PHONE */}

                              <td>{member.phone}</td>

                              {/* EMAIL */}

                              <td>{member.email}</td>

                              {/* PLAN */}

                              <td>{member.membershipPlan}</td>

                              {/* TRAINER */}

                              <td>
                                {member.trainerName || (
                                  <span style={{ color: "red" }}>
                                    Not Assigned
                                  </span>
                                )}
                              </td>

                              {/* WORKOUT */}

                              {gymSettings?.features?.aiWorkout && (
                                <td>{getWorkoutName(member.workoutPlanId)}</td>
                              )}

                              {/* DIET */}

                              {gymSettings?.features?.dietPlan && (
                                <td>{getDietName(member.dietPlanId)}</td>
                              )}

                              {/* JOIN DATE */}

                              <td>{member.joinDate || "-"}</td>

                              {/* EXPIRY */}

                              <td>{member.expiryDate || "-"}</td>

                              {/* STATUS */}

                              <td>
                                <span
                                  className={
                                    member.status === "Active"
                                      ? "status-active"
                                      : member.status === "Inactive"
                                        ? "status-inactive"
                                        : "status-expired"
                                  }
                                >
                                  {member.status}
                                </span>
                              </td>

                              {/* ACTIONS */}

                              <td>
                                {/* EDIT */}

                                <button
                                  className="edit-btn"
                                  onClick={() =>
                                    navigate(`/members/edit/${member.id}`)
                                  }
                                >
                                  Edit
                                </button>

                                {/* DELETE */}

                                <button
                                  className="delete-btn"
                                  onClick={() => handleDelete(member.id)}
                                >
                                  Delete
                                </button>

                                {/* RENEW */}

                                {gymSettings?.features?.idCard &&
                                  isExpired(member.expiryDate) && (
                                    <button
                                      className="renew-btn"
                                      onClick={() => handleRenew(member)}
                                    >
                                      Renew
                                    </button>
                                  )}

                                {/* ID CARD */}

                                {gymSettings?.features?.idCard && (
                                  <button
                                    className="card-btn"
                                    onClick={async () => {
                                      const settings = await getSettings();

                                      generateMemberCard(member, settings);
                                    }}
                                  >
                                    ID Card
                                  </button>
                                )}

                                {/* WORKOUT PDF */}

                                {gymSettings?.features?.aiWorkout && (
                                  <button
                                    className="workout-btn"
                                    onClick={() => {
                                      const workoutPlan = workoutPlans.find(
                                        (plan) =>
                                          plan.id === member.workoutPlanId,
                                      );

                                      generateWorkoutPDF(
                                        member,
                                        workoutPlan,
                                        gymSettings,
                                      );
                                    }}
                                  >
                                    <FaDumbbell
                                      style={{
                                        marginRight: "6px",
                                      }}
                                    />
                                    Workout PDF
                                  </button>
                                )}

                                {/* DIET PDF */}

                                {gymSettings?.features?.dietPlan && (
                                  <button
                                    className="diet-btn"
                                    onClick={() => {
                                      const dietPlan = dietPlans.find(
                                        (plan) => plan.id === member.dietPlanId,
                                      );

                                      generateDietPDF(
                                        member,
                                        dietPlan,
                                        gymSettings,
                                      );
                                    }}
                                  >
                                    <FaAppleAlt
                                      style={{
                                        marginRight: "6px",
                                      }}
                                    />
                                    Diet PDF
                                  </button>
                                )}

                                {/* WHATSAPP */}

                                {gymSettings?.features?.memberPortal && (
                                  <button
                                    className="whatsapp-btn action-btn"
                                    title="Send WhatsApp"
                                    onClick={() => {
                                      const portalLink = `${window.location.origin}/member/${member.accessToken}`;

                                      const message = `Hello ${member.fullName},

Welcome to **${gymSettings.gymName}**

1. Member Name : ${member.fullName}
2. Phone : ${member.phone}
3. Membership : ${member.membershipPlan}
4. Expiry Date : ${member.expiryDate}

Your Member Portal

${portalLink}

From your portal you can:

1. Download ID Card
2. Download Workout Plan
3. Download Diet Plan
4. View Membership Details

Thank you for choosing us.

Powered By NN FIT`;

                                      window.open(
                                        `https://wa.me/91${member.phone}?text=${encodeURIComponent(
                                          message,
                                        )}`,
                                        "_blank",
                                      );
                                    }}
                                  >
                                    <FaWhatsapp />
                                  </button>
                                )}
                              </td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </table>
                  </div>
                </div>
              );
            })}
          </div>
        ) : (
          <div className="members-empty">
            <h3>No Members Found</h3>

            <p>No members match your search.</p>
          </div>
        )}
      </div>
    </DashboardLayout>
  );
}
